export function formatEuros(num) {
  return parseFloat(Math.round(num * 100) / 100).toFixed(2)
}

export function centsInSpan(num) {
  return formatEuros(num).toString().replace(/\.([0-9]{2,2})/, ',<span>$1</span>')
}

export default { formatEuros, centsInSpan }
